module.exports = __webpack_public_path__ + "img/thunderstorm.87ad537f.svg";